import { Box } from '@mui/material';
import { CatalogListDragItemData } from '../../utils/catalogListDragAndDrop.types';
import CatalogCard, { CatalogCardProps } from '../CatalogCard/CatalogCard';
import { useDraggableCatalogCard } from './hooks/useDraggableCatalogCard';

export interface DraggableCatalogCardConfig {
  activeId: string | null;
  isDraggingDisabled: boolean;
  data: CatalogListDragItemData;
}

interface DraggableCatalogCardProps {
  catalogCard: CatalogCardProps;
  drag: DraggableCatalogCardConfig;
}

const DraggableCatalogCard = ({ catalogCard, drag }: DraggableCatalogCardProps) => {
  const catalogId = catalogCard.catalog.id;
  const { attributes, listeners, setCardRef } = useDraggableCatalogCard({
    id: catalogId,
    isDraggingDisabled: drag.isDraggingDisabled,
    data: drag.data,
  });

  const isActive = drag.activeId === catalogId;
  const isDragActive = drag.activeId !== null;

  return (
    <Box
      ref={setCardRef}
      {...attributes}
      {...listeners}
      sx={{
        height: '100%',
        opacity: isActive ? 0.4 : 1,
        cursor: drag.isDraggingDisabled ? 'default' : 'grab',
        pointerEvents: isDragActive ? 'none' : undefined,
      }}
    >
      <CatalogCard {...catalogCard} />
    </Box>
  );
};

export default DraggableCatalogCard;
